import { PagesPermission } from "src/app/modules/utils/model/pages.config";

export class OnboardingResume{
    status : string;
    currentStep : number;
    onboardingVersion : number;
    currentSubStep : string;
    percentage : number;
    flags : Flags;
    language : string;
    channelTypeToUse : string[];
    step1Initialize : boolean;
    step2Initialize : boolean;
    step3Initialize : boolean;
    step4Initialize : boolean;
    step5Initialize : boolean;
    step6Initialize : boolean;
    userStep : UserStep;
}

export class SendInstructionsRequest{
    name : string | null;
    surname : string | null;
    email : string;
    type : string | null;
}
export class UploadFile{
    originalFileName : string;
    fileUrl : string;
    uploadedStep? : number;
}
export class Flags{
    accordionCompany : boolean;
    accordionAccountsReceivable : boolean;
    accordionUploadMethod : boolean;
    accordionCollectionManagement : boolean;
    // enablePreSettings : boolean;
    enablePlatform : boolean;
    enableStep3Menu : boolean;
    alertDisplayed : boolean;
    accordionPaymentMethods : boolean;
    accordionWebForm : boolean;
    accordionWhatsApp : boolean;
    accordionEmail : boolean;
}

export class OnboardingCatalog{
    cluster : string;
    criteriaDescription : string;
    registerData : Date;
}

export class UserStep{
    step : number;
    userId : string;
    currentSubStep : string;
}

export enum OnboardingStepNumber{
    WELCOME_STEP = 0,
    MEETING_STEP = 1,
    PROJECT_INFORMATION_STEP = 2,
    MAIN_USERS_STEP = 3,
    PAYMENT_METHODS_AND_PORTAL_STEP = 4,
    COMMUNICATION_CHANNELS = 5,
    INTEGRATIONS_DATA = 6,
    CHECKLIST = 7,
    TASKS = 8
}

export enum OnboardingStatus {
    PENDING_STATUS = "P",
    CONFIGURED_STATUS = "C",
    RUNNING_STATUS = "R",
    FINISHED_STATUS = "F",
    NOT_CONFIGURED_STATUS = "N",
}

export enum IntegrationType {
    API_UPLOAD_DATA_TYPE = 'A',
    FILE_UPLOAD_DATA_TYPE = 'F',
    ERP_UPLOAD_DATA_TYPE = 'E',
    DONT_KNOW_UPLOAD_DATA_TYPE = 'D'
}

export enum CommunicationTone{
    INFORMAL = "I",
    FORMAL = "F",
}

export enum PrincipalPaymentCurrencyEnum {
    LOCAL = 'LOCAL',
    USD = 'USD'
}

export enum OnboardingRolId{
    RESPONSIBLE_ONBOARDING = 1,
    SPONSOR = 2,
    TECHNICAL_MANAGER = 3,
    ADVISER = 4
}

export class OnboardingProjectPermission {
    step : number;
    visible : boolean;
    edit : boolean;
}

export enum SendInstructionsEmailType {
    SAME_EMAIL_ADDRESS_INSTRUCTIONS = "SEA",
    DIFFERENT_EMAIL_ADDRESS_INSTRUCTIONS = "DEA",
    CONFIGURE_DKIM_INSTRUCTIONS = "CD",
    CONNECT_API_INSTRUCTIONS = "CA",
    WHATSAPP_PERSONAL_INSTRUCTIONS = "WP",
    WHATSAPP_BUSINESS_INSTRUCTIONS = "WB"
}

export enum InstructionsValidation{
    NOT_INVITED = "NOT_INVITED",
    ALREADY_INVITED = "ALREADY_INVITED",
    NOT_ACTIVE = "NOT_ACTIVE",
    ACTIVE = "ACTIVE"
}

export const OnboardingStepConfig = [
    { "step": OnboardingStepNumber.MEETING_STEP, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.PROJECT_INFORMATION_STEP, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.MAIN_USERS_STEP, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.PAYMENT_METHODS_AND_PORTAL_STEP, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.COMMUNICATION_CHANNELS, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.CHECKLIST, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.INTEGRATIONS_DATA, "key": PagesPermission.ONBOARDING},
    { "step": OnboardingStepNumber.TASKS, "key": PagesPermission.ONBOARDING}
];
